// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","spacer":"spacer__YgDi6","back_button":"back_button__b6DG4"};